import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { authFetch } from "../api/api";
import Card from "../UI/Card";
import Button from "../UI/Button";
import UploadPhotoModal from "./modals/UploadPhotoModal";

const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;
const API_URL = `${BASE_URL}/api/orders/`;

export default function OrderPhotosPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const loadPhotos = async () => {
    try {
      const res = await authFetch(`${API_URL}${id}/photos/`);
      const data = await res.json();
      setPhotos(data);
    } catch (err) {
      console.error("photos error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPhotos();
  }, [id]);

  const handleDelete = async (photoId) => {
    try {
      await authFetch(`${API_URL}${id}/photos/${photoId}/`, {
        method: "DELETE",
      });

      setPhotos((prev) => prev.filter((p) => p.id !== photoId));
    } catch (err) {
      console.error("delete error:", err);
    }
  };

  if (loading) return <div className="mt-10">Loading...</div>;

  return (
    <div className="max-w-5xl mx-auto mt-10 space-y-6">

      {/* HEADER */}
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">Фотоматериалы</h1>

        <Button onClick={() => setShowModal(true)}>
          Добавить фото
        </Button>
      </div>

      {/* LIST */}
      {photos.length === 0 ? (
        <p className="text-gray-500">Нет фото</p>
      ) : (
        <div className="grid grid-cols-2 gap-4">
          {photos.map((photo) => (
            <Card key={photo.id}>
              <img
                src={photo.image}
                className="w-full h-40 object-cover rounded"
              />

              {photo.comment && (
                <p className="text-sm text-gray-600 mt-2">
                  {photo.comment}
                </p>
              )}

              <div className="flex gap-2 mt-3">
                <Button
                  onClick={() => alert("edit later")}
                >
                  Редактировать
                </Button>

                <Button
                  onClick={() => handleDelete(photo.id)}
                >
                  Удалить
                </Button>
              </div>
            </Card>
          ))}
        </div>
      )}

      {/* MODAL */}
      {showModal && (
        <UploadPhotoModal
          orderId={id}
          onClose={() => setShowModal(false)}
          onSuccess={() => {
            setShowModal(false);
            loadPhotos();
          }}
        />
      )}

      {/* BACK */}
      <div>
        <Button onClick={() => navigate(-1)}>
          Назад
        </Button>
      </div>
    </div>
  );
}